import React from 'react'
import styled from 'styled-components';
import ourgoals from '../../Images/about/ourgoals.png'

const OurGoalsContent = () => {
    return (
        <Container>
            <div className="first">
                <div className="our__mission">
                    <h4>Our Mission</h4>
                    <p>To serve our customers to the best by delivering technically sound and affordable business solutions while ensuring exceptional customer support throughout the process.</p>
                </div>
                <div className="image">
                    <img src={ourgoals} alt="our goals" />
                </div>
                <div className="our__vision">
                    <h4>Our Vision</h4>
                    <p>To become a prime performer in the global marketplace by providing highly innovative web designing, web development and internet marketing services that will drive our client's business towards growth.</p>
                </div>
            </div>

            <div className="second">
                <div className="our__values">
                    <h4>Our Values</h4>
                    <p>Businesses and innovation of new technology should go hand in hand for better results and over all development. With appropriate offshore development service we always aim for reaching greater heights. We store for attaining the zenith in our chosen field.</p>
                </div>
            </div>
        </Container>
    )
}

export default OurGoalsContent


const Container = styled.div`
    background: #fff;
    h4{
        font-size: 1.5rem;
        color: #000219;
    }
    p{
        color: #000219;
        font-size: 1.2rem;
    }
    .first{
        display: flex;
        .our__mission{
            display: flex;
            flex-direction: column;
            flex: 1;
            padding: 1rem;
        }
        .image{
            display: flex;
            flex-direction: column;
            flex: 1;
            padding: 1rem;
            img{
                width: 100%;
                height: auto;
            }
        }
        .our__vision{
            display: flex;
            flex-direction: column;
            flex: 1;
            padding: 1rem;
            text-align: right;
        }
        @media screen and (max-width: 900px){
            flex-direction: column;
            .our__mission, .our__vision{
                padding: 1rem 0.5rem;
                text-align: center;
            }
        }
    }
    .second{
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        .our__values{
            padding: 1rem 18rem;
        }
        @media screen and (max-width: 900px){
            .our__values{
                padding: 1rem 0.5rem;
                text-align: center;
            }
        }
    }
`